import { ActionTypes, ToolbarModel } from './model'

export default function handler(state = new ToolbarModel(), actions) {
    return state;
}